import styled from 'styled-components';

export const UnderlinedTr = styled.tr`
  text-decoration: underline;
`;
